import { useMediaQuery } from "@material-ui/core";

import {
  FOOTER_HEIGHT,
  FOOTER_HEIGHT_SM,
  FOOTER_BREAKPOINT,
  contentHeightFor,
} from "../constants/layout";

// useFooterHeight — chiều cao footer THỰC TẾ đang hiển thị. Bám theo đúng media
// query trong AppFooter.css (≤960px thì footer cao 60px thay vì 30px).
export const useFooterHeight = () => {
  const isNarrow = useMediaQuery(`(max-width:${FOOTER_BREAKPOINT}px)`);
  return isNarrow ? FOOTER_HEIGHT_SM : FOOTER_HEIGHT;
};

// useContentHeight — chuỗi calc() cho chiều cao vùng nội dung, đã trừ header và
// footer theo đúng kích thước đang hiển thị.
export const useContentHeight = () => contentHeightFor(useFooterHeight());

export default useContentHeight;
